import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router/composables';
import { Heading, Row } from '@warrenbrasil/nebraska-web';
import {
  getNotifications,
  INotification,
  ETypeNotification,
  getNews,
  NewsResponse
} from '@/modules/home/services/bff';
import VerifyEmailModal from '@/modules/home/components/HomeNotifications/components/VerifyEmailModal/VerifyEmailModal.vue';
import { CustomerModule } from '@/modules/common/store/CustomerModule';


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeNotifications',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const notifications = ref<INotification[]>([]);
const suggestions = ref<NewsResponse['getInvestmentSuggestions']>();

const isOpenVerifyEmailModal = ref(false);

onMounted(() => fetchData());

const fetchData = async () => {
  try {
    notifications.value = (await getNotifications()).notifications;
    const hasSuggestions = notifications.value.some(
      notification =>
        notification.action.type === ETypeNotification['open-suggestions']
    );
    if (hasSuggestions) {
      getSuggestions();
    }
  } catch (error) {}
};

const getSuggestions = async () => {
  try {
    const { getInvestmentSuggestions } = await getNews(
      CustomerModule.getCustomerId
    );
    suggestions.value = getInvestmentSuggestions;
  } catch {}
};

const handleSuggestions = () => {
  if (suggestions.value?.showSuggestions) {
    router.push({ name: 'investmentSuggestions' });
  }
};

const handlePortability = () => {
  router.push({ name: 'portabilityRequests' });
};

const handleVerifyEmail = () => {
  handleToggleVerifyEmailModal();
};

const goToAction = (action: ETypeNotification) => {
  switch (action) {
    case ETypeNotification['open-verify-email']:
      handleVerifyEmail();
      break;
    case ETypeNotification['open-suggestions']:
      handleSuggestions();
      break;
    case ETypeNotification['open-portability']:
      handlePortability();
      break;
    case ETypeNotification['open-suitability']:
      router.push({
        query: {
          ...route.query,
          suitabilityModal: 'true'
        }
      });
      break;
    default:
      break;
  }
};

const handleToggleVerifyEmailModal = () => {
  isOpenVerifyEmailModal.value = !isOpenVerifyEmailModal.value;
};

return { __sfc: true,router, route, notifications, suggestions, isOpenVerifyEmailModal, fetchData, getSuggestions, handleSuggestions, handlePortability, handleVerifyEmail, goToAction, handleToggleVerifyEmailModal, Heading, Row, VerifyEmailModal }
}

})